export interface IdentityUserData {
  id: string;
  userName: string;
  firstName: string;
  lastName: string;
  email: string;
  company: string;
}
